import { getPropertyValueByCode } from "src/services/property/getPropertyByCode";
import { PropertyValue } from "src/types/property";

import { useFormatPropertyValue } from "./useFormatProperty";

export const useFormatPropertyByCode = () => {
  const formatPropertyValue = useFormatPropertyValue();

  const formatPropertyByCode = (properties: PropertyValue[], code: string) => {
    const property = getPropertyValueByCode(properties, code);
    if (!property) return "";
    return formatPropertyValue(property);
  };

  return formatPropertyByCode;
};
